module.exports = __webpack_public_path__ + "img/emt-logo-small.0029d4c2.png";